import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'followupMention',
  standalone: true,
})
export class FollowupMentionPipe implements PipeTransform {
  transform(value: string | null | undefined, maxLength?: number, plainTextOnly: boolean = false): string {
    if (!value) {
      return '';
    }

    const tokens = this.tokenize(value);
    if (plainTextOnly) {
      const normalizedValue = tokens.map((token) => token.value).join('');
      if (!maxLength || maxLength < 0 || normalizedValue.length <= maxLength) {
        return normalizedValue;
      }

      return normalizedValue.slice(0, maxLength) + '...';
    }

    if (!maxLength || maxLength < 0) {
      return tokens
        .map((token) => this.renderToken(token, token.value.length))
        .join('');
    }

    let remaining = maxLength;
    let truncated = false;
    let result = '';

    for (const token of tokens) {
      if (remaining <= 0) {
        truncated = true;
        break;
      }

      const sliceLength = Math.min(token.value.length, remaining);
      result += this.renderToken(token, sliceLength);
      remaining -= sliceLength;

      if (sliceLength < token.value.length) {
        truncated = true;
        break;
      }
    }

    return truncated ? result + '...' : result;
  }

  private tokenize(value: string): Array<{ value: string; isMention: boolean }> {
    const tokens: Array<{ value: string; isMention: boolean }> = [];
    const mentionPattern = /@\[([^\]]+)\]/g;
    let lastIndex = 0;
    let match: RegExpExecArray | null;

    while ((match = mentionPattern.exec(value)) !== null) {
      if (match.index > lastIndex) {
        tokens.push({
          value: value.slice(lastIndex, match.index),
          isMention: false,
        });
      }

      tokens.push({ value: match[1], isMention: true });
      lastIndex = match.index + match[0].length;
    }

    if (lastIndex < value.length) {
      tokens.push({ value: value.slice(lastIndex), isMention: false });
    }

    return tokens;
  }

  private renderToken(token: { value: string; isMention: boolean }, sliceLength: number): string {
    const escapedValue = this.escapeHtml(token.value.slice(0, sliceLength));
    if (!token.isMention) {
      return escapedValue;
    }

    return '<span class="followup-mentioned-user">' + escapedValue + '</span>';
  }

  private escapeHtml(value: string): string {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
}